<template>
  <v-app>
    <v-container style="padding-bottom: 20vh">
      <v-row class="justify-center">
        <v-col class="col-12 col-md-10">
          <h2 class="text-center text-md-left primary--text ml-md-4">
            <v-icon size="50" class="primary--text mr-2"> record_voice_over </v-icon>
            Paciente
          </h2>
          <v-divider class="mt-3"></v-divider>
        </v-col>
      </v-row>

      <v-row class="justify-center">
        <v-col class="col-12 col-md-5 col-lg-5 px-3">
          <v-col class="col-12 d-flex align-center justify-end">
            <div
              class="pl-12"
              style="
                background: #fffde3;
                padding: 13px 0;
                border-radius: 12px;
                width: calc(100% - 46px);
                position: relative;
              "
            >
              <div style="position: absolute; left: -50px; top: 0">
                <v-avatar size="90">
                  <v-img v-if="patient.photo != ''" :src="patient.photo">
                    <template v-slot:placeholder>
                      <v-row fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>

                  <v-img
                    v-if="patient.photo == ''"
                    :src="require('../../assets/no-image.png')"
                  ></v-img>
                </v-avatar>
              </div>
              <p class="mb-2 font-weight-bold subheading">{{ patient.name }}</p>
              <p class="ma-0">
                <span class="font-weight-bold">Nacionalidade:</span>
                {{ patient.country }}
              </p>
            </div>
          </v-col>
          <div class="d-flex mt-4">
            <v-col class="col-6 ml-2">
              <p>
                <span class="font-weight-bold">Sexo:</span>
                {{ patient.gender }}
              </p>
            </v-col>
            <v-col class="col-6">
              <p>
                <span class="font-weight-bold">Nascimento:</span>
                {{ patient.date_birth }}
              </p>
            </v-col>
          </div>
          <v-divider></v-divider>
          <div class="d-flex mt-4">
            <v-col class="col-6 ml-2">
              <p>
                <span class="font-weight-bold">{{ $t('pageProfile.labelDestrito') }}:</span>
                {{ patient.state }}
              </p>
            </v-col>
            <v-col class="col-6">
              <p>
                <span class="font-weight-bold">Cidade:</span>
                {{ patient.city }}
              </p>
            </v-col>
          </div>
          <v-divider></v-divider>
        </v-col>
        <v-col class="col-12 col-md-5 col-lg-5 px-3">
          <div>
            <h3 class="my-4">{{ $t('pageProfile.titleContato') }}</h3>
            <div>
              <div class="mb-3 box-contact d-flex align-center" v-if="patient.telephone">
                <span> Telefone </span>
                <v-img
                  :src="require('../../assets/icon-call.svg')"
                  width="28px"
                  class="mx-2"
                ></v-img>
                <p>{{ patient.telephone }}</p>
              </div>
              <div class="mb-3 box-contact d-flex align-center" v-if="patient.whatsapp">
                <span> WhatsApp </span>
                <v-img
                  :src="require('../../assets/logo-whatsapp.svg')"
                  width="28px"
                  class="mx-2"
                ></v-img>
                <p>{{ patient.whatsapp }}</p>
              </div>
              <div class="mb-3 box-contact d-flex align-center" v-if="patient.hangouts">
                <span> Hangouts </span>
                <v-img
                  :src="require('../../assets/icon-hangout.svg')"
                  width="28px"
                  class="mx-2"
                ></v-img>
                <p>{{ patient.hangouts }}</p>
              </div>
              <div class="mb-3 box-contact d-flex align-center" v-if="patient.messenger">
                <span> Messenger </span>
                <v-img
                  :src="require('../../assets/icon-messenger.svg')"
                  width="28px"
                  class="mx-2"
                ></v-img>
                <p>{{ patient.messenger }}</p>
              </div>
              <div class="mb-3 box-contact d-flex align-center" v-if="patient.skype">
                <span> Skype </span>
                <v-img
                  :src="require('../../assets/logo-skype.svg')"
                  width="28px"
                  class="mx-2"
                ></v-img>
                <p>{{ patient.skype }}</p>
              </div>
              <div class="mb-3 box-contact d-flex align-center" v-if="patient.email">
                <span> Email </span>
                <v-img
                  :src="require('../../assets/icon-mail.svg')"
                  width="28px"
                  class="mx-2"
                ></v-img>
                <p>{{ patient.email }}</p>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col class="col-12 col-md-10">
          <div
            class="yellow pa-3 d-flex align-center align-center justify-center justify-md-start px-5"
          >
            <v-icon size="50" class="primary--text mr-2"> content_paste </v-icon>
            <span class="primary--text lato-bold text-h5">Prontuários</span>
          </div>
        </v-col>
      </v-row>
      <div>
        <v-row justify="center" v-if="!isLoading && patientMedicalRecords.length === 0">
          <v-col class="col-12 col-md-6 col-lg-4">
            <h2 class="text-center primary--text">Você não possui prontuários.</h2>
          </v-col>
        </v-row>

        <div v-if="!isLoading && patientMedicalRecords.length > 0" class="grid-records">
          <div
            v-for="(item, index) in createPagination(patientMedicalRecords)[pageRecord - 1]"
            :key="index"
            class="grid-card"
          >
            <MedicalRecordItem :medicalRecord="item" />
          </div>
        </div>
      </div>
      <footer class="pagination-records">
        <v-pagination
          v-model="pageRecord"
          v-if="patientMedicalRecords.length !== 0"
          :length="createPagination(patientMedicalRecords).length"
        ></v-pagination>
      </footer>
    </v-container>
  </v-app>
</template>

<script>
import moment from 'moment-timezone';
import MedicalRecordItem from '@/components/MedicalRecordItem';
import { getProfile, getPatientMedicalRecords } from '../../services/patient';

export default {
  name: 'PatientProfile',
  data() {
    return {
      id: null,
      patient: Object,
      patientMedicalRecords: [],
      pageRecord: 1,
    };
  },
  components: {
    MedicalRecordItem,
  },
  created() {
    this.id = this.$route.params.id;
    this.pegaPerfil();
  },
  methods: {
    async pegaPerfil() {
      const res = await getProfile(this.id);

      if (res.status === 200) {
        this.patient = res.data;
        console.log(this.patient);

        const recordsResponse = await getPatientMedicalRecords(this.id);
        this.patientMedicalRecords = recordsResponse.data.results;
        this.formatData(this.patient.date_birth);
      }
    },
    createPagination(data) {
      const cache = [];
      let i = 0;
      while (i < data.length) {
        cache.push(data.slice(i, i + 10));
        i += 10;
      }
      return cache;
    },
    formatData(v) {
      this.patient.date_birth = !v ? '' : moment(v).format('DD/MM/YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
.box-contact {
  background-color: #f7f7f7;
  padding: 16px;
  color: #6f6f6f;
  font-size: 18px;
  flex-wrap: wrap;

  > * {
    flex: 0 0 auto !important;
  }

  p {
    margin: 0;
  }

  span {
    font-size: 20px;
    margin-right: 20px;
    font-weight: bold;
  }
}

h2 {
  color: var(--v-primary-base);
}

.specialities {
  padding: 10px 15px;
  background: green;
  color: white;
  border-radius: 15px;
}

.photoOPP {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  border: solid 1px #707070;
  padding: 32px 16px;
  border-radius: 10px;
}

.biographty-text {
  white-space: pre-wrap;
  p {
    margin-bottom: 0;
  }
}
.grid-records {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, min(100%, 550px));
  justify-content: space-around;
  grid-gap: 10px;
}
.grid-records > div {
  width: 100% !important;
}
.grid-card {
  padding: 10px 20px;
  background: #f8f8f8;
  border-radius: 5px;
}
.pagination-records {
  margin-top: 30px;
}
</style>
